import { makeStyles } from "@mui/styles";

import theme from "src/theme";
import titleWaveGold from "src/assets/icons/tournaments/titleWave2.png";
import titleWaveSilver from "src/assets/icons/tournaments/titleWaveSilver.png";

const width = window.innerWidth - 20;
const animMulti = 0.17;

const baseParagrAnimStyles = {
    animationIterationCount: 1,
    animationFillMode: "forwards",
    animationDuration: "600ms",
    animationName: "paragraphTextBlockAnim",
};

const baseCoinAreaAnimStyles = {
    animationIterationCount: 1,
    animationFillMode: "forwards",
    animationDuration: "600ms",
    animationName: "coinBaseAreaAnim",
};

export const useStyles = makeStyles({
    "@global": {
        "@keyframes textWrapperAnim": {
            "0%": {
                transform: "translate(-50%, -50%)",
                gridGap: "0px",
            },
            "55%": {
                transform: "translate(-50%, -190%) scale(1.06)",
                gridGap: "10px",
            },
            "100%": {
                transform: "translate(-50%, -190%) scale(1)",
                gridGap: "5px",
            },
        },
        "@keyframes winnerTournamentBoxAnim": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -50%)",
                gridGap: "0px",
                height: "48px",
                filter: "drop-shadow(0px 0px 0px #F8BF44)",
            },
            "40%": {
                filter: "drop-shadow(0px 0px 0px #F8BF44)",
            },
            "90%": {
                filter: "drop-shadow(0px 0px 28px #F8BF44)",
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, 125%)",
                gridGap: "5px",
                height: "48px",
                filter: "drop-shadow(0px 0px 5px #F8BF44)",
            },
        },
        "@keyframes secondTournamentBoxAnim": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -50%)",
                gridGap: "0px",
                height: "50px",
                filter: "drop-shadow(0px 0px 0px #C9C0BB)",
            },
            "40%": {
                filter: "drop-shadow(0px 0px 0px #C9C0BB)",
            },
            "90%": {
                filter: "drop-shadow(0px 0px 30px #C9C0BB)",
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, 125%)",
                gridGap: "3px",
                height: "50px",
                filter: "drop-shadow(0px 0px 5px #C9C0BB)",
            },
        },
        "@keyframes thirdTournamentBoxAnim": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -50%)",
                gridGap: "0px",
                height: "50px",
                filter: "drop-shadow(0px 0px 0px #C9C0BB)",
            },
            "40%": {
                filter: "drop-shadow(0px 0px 0px #C9C0BB)",
            },
            "90%": {
                filter: "drop-shadow(0px 0px 30px #C9C0BB)",
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, 125%)",
                gridGap: "3px",
                height: "50px",
                filter: "drop-shadow(0px 0px 5px #C9C0BB)",
            },
        },
        "@keyframes coinBaseAreaAnim": {
            "0%": {
                transform: "translateY(-950%)",
                opacity: 1,
            },
            "45%": {
                opacity: 0.7,
            },
            "100%": {
                transform: "translateY(0%)",
                opacity: 0,
            },
        },
        "@keyframes paragraphTextBlockAnim": {
            "0%": {
                transform: "scale(0) translateX(-100%) translateY(200%)",
                rotate: "-180deg",
                opacity: 0.1,
            },
            "45%": {
                transform: "scale(2.5)",
            },
            "80%": {
                rotate: "0deg",
                transform: "translateX(0px) translateY(0px)",
            },
            "100%": {
                transform: "scale(1) translateX(0px) translateY(0px)",
                opacity: 1,
            },
        },

        "@keyframes otherTournamentBoxAnim": {
            "0%": {
                opacity: 0,
                transform: "translate(-50%, -50%)",
                gridGap: "0px",
                height: "48px",
                filter: "drop-shadow(0px 0px 0px #CD7F32)",
            },
            "40%": {
                filter: "drop-shadow(0px 0px 0px #CD7F32)",
            },
            "90%": {
                filter: "drop-shadow(0px 0px 28px #CD7F32)",
            },
            "100%": {
                opacity: 1,
                transform: "translate(-50%, 130%)",
                gridGap: "5px",
                height: "48px",
                filter: "drop-shadow(0px 0px 3px #CD7F32)",
            },
        },

        "@keyframes winnerTroffyAnim": {
            "0%": {
                opacity: 0,
            },
            "100%": {
                opacity: 1,
            },
        },
        "@keyframes winnerTroffyAnim2": {
            "0%": {
                filter: "drop-shadow(0 0 0.1rem #ffd70096)",
            },
            "40%": {
                filter: "drop-shadow(0 0 1.5rem #ffd987ad)",
            },
            "60%": {
                filter: "drop-shadow(0 0 1.5rem #ffd987ad)",
            },
            "80%": {
                filter: "drop-shadow(0 0 1.5rem #ffd70096)",
            },
            "100%": {
                filter: "drop-shadow(0 0 0.1rem #ffd70096)",
            },
        },
        "@keyframes winnerTroffyAnim3": {
            "0%": {
                filter: "drop-shadow(0 0 0.1rem silver)",
            },
            "40%": {
                filter: "drop-shadow(0 0 1.5rem gray)",
            },
            "60%": {
                filter: "drop-shadow(0 0 1.5rem gray)",
            },
            "80%": {
                filter: "drop-shadow(0 0 1.5rem silver)",
            },
            "100%": {
                filter: "drop-shadow(0 0 0.1rem silver)",
            },
        },
        "@keyframes titleBlitz": {
            "0%": { backgroundPosition: "0% 50%" },
            "100%": { backgroundPosition: "100% 50%" },
        },
        "@keyframes showShineBkg": {
            "0%": { opacity: 0 },
            "40%": { opacity: 1 },
            "70%": { opacity: 1 },
            "100%": { opacity: 0.6 },
        },
    },
    dialog: {
        padding: "0px 9px",
        animationName: "$dialogSpin",
        animationIterationCount: 1,
        animationFillMode: "forwards",
        animationDuration: "400ms",
        backdropFilter: "blur(5px)",
    },
    dialogPaperWinnerTour: {
        maxWidth: 1024,
        height: "100%",
        width: "100%",
        boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "25px 10px",
        margin: 0,
        overflowY: "unset",
        borderRadius: "50px",
        gridGap: "20px",
        background:
            "linear-gradient(180deg, saddlebrown 0%, #000000 70%, #000000 100%)",
        border: "1px solid #0001",
        "&.place1": {
            border: "1px solid #ffd70070",
            background:
                "linear-gradient(180deg, #a1652969 0%, #000000 70%, #000000 100%)",
        },
        "&.place2": {
            border: "1px solid silver",
            background:
                "linear-gradient(180deg, silver 0%, #000000 70%, #000000 100%)",
        },
        "&.place3": {
            border: "1px solid #CD7F32",
            background:
                "linear-gradient(180deg, #CD7F32 0%, #000000 70%, #000000 100%)",
        },        
        [theme.breakpoints.down("md")]: {
            maxWidth: "95%",
        },
        "@media screen and (max-width: 768px) and (max-height: 680px)": {
            minHeight: "98%",
            gridGap: "10px",
            justifyContent: "space-between",
        },
    },

    crossWrapper: {
        position: "absolute",
        top: "30px",
        left: "30px",
        zIndex: 3,
        cursor: 'pointer',
    },

    cross: ({ place }: any) => ({
        width: 40,
        height: 40,
        position: "relative",
        "&::before": {
            content: '""',
            display: "block",
            width: "110%",
            height: "2px",
            position: "absolute",
            top: "50%",
            left: "50%",
            "-webkit-transform": "translate(-50%,-50%) rotate(45deg)",
            transform: "translate(-50%,-50%) rotate(45deg)",
            background:
                place < 2
                    ? "linear-gradient(180deg, #F8BF44 0%, #A16529 100%)"
                    : "linear-gradient(180deg, gray 0%, black 100%)",
            boxShadow: "1px 1px 9px #eee",
        },
        "&::after": {
            content: '""',
            display: "block",
            width: "110%",
            height: "2px",
            position: "absolute",
            top: "50%",
            left: "50%",
            "-webkit-transform": "translate(-50%,-50%) rotate(-45deg)",
            transform: "translate(-50%,-50%) rotate(-45deg)",
            background:
                place < 2
                    ? "linear-gradient(180deg, #F8BF44 0%, #A16529 100%)"
                    : "linear-gradient(180deg, gray 0%, black 100%)",
            boxShadow: "1px 1px 9px #eee",
        },
        [theme.breakpoints.down("sm")]: {
            width: 35,
            height: 35,
        },
    }),

    conditions: {
        position: "absolute",
        top: "50%",
        left: "50%",
        height: "0px",
        width: "0px",
        transform: "translate(-50%, -50%)",
    },

    winnerAnimationBox: {},

    winnerTroffyBox: ({ myLength }: any) => ({
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        height: "fit-content",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gridGap: "22px",
        flexWrap: "wrap",
        animationName: "winnerTroffyAnim",
        animationDelay: myLength >= 10 ? "5.6s" : "3.5s",
        opacity: 0,
        animationIterationCount: 1,
        animationFillMode: "forwards",
        animationDuration: "2000ms",
    }),

    winnerTournamentBox: ({ myLength }: any) => ({
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        // height: 'fit-content',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gridGap: "22px",
        flexWrap: "wrap",
        height: "50px",
        animationName: "otherTournamentBoxAnim",
        animationDelay: myLength >= 10 ? "6.1s" : "4.0s",
        opacity: 0,
        animationIterationCount: 1,
        animationFillMode: "forwards",
        animationDuration: "1000ms",
        "&.place1": {
            animationName: "winnerTournamentBoxAnim",
            animationDelay: myLength >= 10 ? "6.1s" : "4.0s",
            opacity: 0,
            animationIterationCount: 1,
            animationFillMode: "forwards",
            animationDuration: "1000ms",
        },
        "&.place2": {
            animationName: "secondTournamentBoxAnim",
            animationDelay: myLength >= 10 ? "6.1s" : "4.0s",
            opacity: 0,
            animationIterationCount: 1,
            animationFillMode: "forwards",
            animationDuration: "1000ms",
        },
        "&.place3": {
            animationName: "thirdTournamentBoxAnim",
            animationDelay: myLength >= 10 ? "6.1s" : "4.0s",
            opacity: 0,
            animationIterationCount: 1,
            animationFillMode: "forwards",
            animationDuration: "1000ms",
        },
    }),

    winnerTournamentSubBox: {
        width: "100%",
        height: "100%",
        position: "relative",
    },

    winnerTournamentBoxShine: ({ myLength }: any) => ({
        display: "none",
        // position: 'absolute',
        // left: '50%',
        // top: '50%',
        // transform: 'translate(-50%, -50%)',
        // zIndex: -1,
        // width: '100%',
        // height: '100px',
        // opacity: 0,
        // filter: 'blur(15px)',
        // animationName: 'showShineBkg',
        // animationDelay: myLength >= 10 ? '7s' : '5s',
        // animationIterationCount: 1,
        // animationFillMode: 'forwards',
        // animationDuration: '1200ms',
        // '&.place1': {
        //     background:
        //         'radial-gradient(50% 4622.78% at 50% 50%, #ffd70096 0%, black 100%)',
        // },
        // '&.place2': {
        //     background:
        //         'radial-gradient(50% 4622.78% at 50% 50%, silver 0%, black 100%)',
        // },
        // [theme.breakpoints.down('sm')]: {
        //     // height: '120px',
        //     height: '20px',
        // },
    }),

    winnerTroffyText: ({ place }: any) => ({
        fontSize: "80px",
        fontWeight: 600,
        filter: "drop-shadow(0 0 0.2rem #ffd70096)",
        margin: 0,
        fontFamily: "Montserrat",
        "&.dollar": {
            filter: "drop-shadow(0 0 0.2rem #ffd70096)",
            animationName: "winnerTroffyAnim2",
            animationDelay: "7.1s",
            opacity: 1,
            animationIterationCount: "infinite",
            animationFillMode: "forwards",
            animationDuration: "4000ms",
            textAlign: "center",
            background: "linear-gradient(180deg, #F8BF44 0%, #A16529 100%)",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
            backgroundClip: "text",
            [theme.breakpoints.down("lg")]: {
                fontSize: "56px",
            },
            [theme.breakpoints.down("sm")]: {
                fontSize: "50px",
            },
        },
        "&.rankPoints": {
            filter: "drop-shadow(0 0 0.2rem silver)",
            animationName: "winnerTroffyAnim3",
            animationDelay: "7.1s",
            opacity: 1,
            animationIterationCount: "infinite",
            animationFillMode: "forwards",
            animationDuration: "4000ms",
            textAlign: "center",
            background: "linear-gradient(to bottom, #bcc6cc, #eee, #bcc6cc)",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
            backgroundClip: "text",
            [theme.breakpoints.down("lg")]: {
                fontSize: "46px",
            },
            [theme.breakpoints.down("md")]: {
                fontSize: "36px",
            },
        },
        "&.tournamentTitle": {
            fontWeight: 500,
            fontSize: "64px",
            filter: "drop-shadow(2px 2px 2px black)",
            textAlign: "center",
            background:
                place < 2
                    ? "linear-gradient(180deg, #F8BF44 0%, #A16529 100%)"
                    : "linear-gradient(180deg, #bcc6cc 0%, #eee 100%)",
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
            backgroundClip: "text",
            [theme.breakpoints.down("lg")]: {
                fontSize: "50px",
            },
            [theme.breakpoints.down("sm")]: {
                fontSize: "42px",
            },
        },
    }),

    textWrapper: ({ myLength }: any) => ({
        animationName: "textWrapperAnim",
        animationDelay: myLength >= 10 ? "5s" : "3s",
        animationIterationCount: 1,
        animationFillMode: "forwards",
        animationDuration: "400ms",
        minWidth: "320px",
        width: "fit-content",
        maxWidth: "1000px",
        height: "100px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        [theme.breakpoints.down("md")]: {
            minWidth: "500px",
            maxWidth: "500px",
            justifyContent: "space-evenly",
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "320px",
            maxWidth: width,
            justifyContent: "center",
        },
    }),

    winnerLetter: ({ place }: any) => ({
        fontSize: "70px",
        margin: 0,
        padding: 0,
        fontWeight: 600,
        textAlign: "center",
        ontFamily: "Montserrat",
        filter: "drop-shadow(3px 3px 3px black)",
        borderRadius: "10px",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-webkit-backface-visibility": "hidden",
        animationName: "titleBlitz",
        animationIterationCount: "infinite",
        animationDelay: "2s",
        animationFillMode: "forward",
        animationDuration: place > 1 ? "12s" : "10s",
        animationTimingFunction: "linear",
        background:
            place < 2
                ? `url(${titleWaveGold}) repeat-y`
                : `url(${titleWaveSilver}) repeat-y`,
        backgroundSize: "cover",

        [theme.breakpoints.down("md")]: {
            fontSize: "42px",
            filter: "drop-shadow(3px 3px 2px black)",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "36px",
            fontWeight: 700,
            filter: "drop-shadow(1px 1px 1px black)",
        },
    }),

    containDiv: {},

    paragraphTextBlock: {
        position: "static",
        minWidth: "50px",
        borderRadius: "16px",
        opacity: 0,
        overflow: "hidden",
        width: "fit-content",
        fontFamily: "Montserrat",
        [theme.breakpoints.down("md")]: {
            width: "38px",
            minWidht: "38px",
        },
        [theme.breakpoints.down(455)]: {
            width: "fit-content",
            minWidth: "33px",
        },
        [theme.breakpoints.down(390)]: {
            minWidth: "28px",
        },
        "&:after": {
            zIndex: "-1",
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: 0,
            height: "38px",
        },
        "&.paragr0": {
            animationDelay: `${animMulti * 5}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr1": {
            animationDelay: `${animMulti * 6}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr2": {
            animationDelay: `${animMulti * 7}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr3": {
            animationDelay: `${animMulti * 8}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr4": {
            animationDelay: `${animMulti * 9}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr5": {
            animationDelay: `${animMulti * 10}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr6": {
            animationDelay: `${animMulti * 11}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr7": {
            animationDelay: `${animMulti * 12}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr8": {
            animationDelay: `${animMulti * 13}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr9": {
            animationDelay: `${animMulti * 14}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr10": {
            animationDelay: `${animMulti * 15}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr11": {
            animationDelay: `${animMulti * 16}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr12": {
            animationDelay: `${animMulti * 17}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr13": {
            animationDelay: `${animMulti * 18}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr14": {
            animationDelay: `${animMulti * 19}s`,
            ...baseParagrAnimStyles,
        },
        "&.paragr15": {
            animationDelay: `${animMulti * 20}s`,
            ...baseParagrAnimStyles,
        },
    },

    coinsWrapper: {
        minWidth: "320px",
        width: "fit-content",
        maxWidth: "1000px",
        height: "400px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
        [theme.breakpoints.down("md")]: {
            justifyContent: "space-evenly",
            minWidth: "500px",
            maxWidth: "500px",
        },
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            minWidth: "320px",
            maxWidth: width,
        },
    },

    coinBaseArea: {
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        opacity: 0,
        [theme.breakpoints.down("md")]: {
            width: "38px",
            height: "38px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "28px",
            height: "28px",
        },
        "&.coinAreaItem0": {
            animationDelay: `${animMulti * 5}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem1": {
            animationDelay: `${animMulti * 6}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem2": {
            animationDelay: `${animMulti * 7}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem3": {
            animationDelay: `${animMulti * 8}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem4": {
            animationDelay: `${animMulti * 9}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem5": {
            animationDelay: `${animMulti * 10}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem6": {
            animationDelay: `${animMulti * 11}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem7": {
            animationDelay: `${animMulti * 12}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem8": {
            animationDelay: `${animMulti * 13}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem9": {
            animationDelay: `${animMulti * 14}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem10": {
            animationDelay: `${animMulti * 15}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem11": {
            animationDelay: `${animMulti * 16}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem12": {
            animationDelay: `${animMulti * 17}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem13": {
            animationDelay: `${animMulti * 18}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem14": {
            animationDelay: `${animMulti * 19}s`,
            ...baseCoinAreaAnimStyles,
        },
        "&.coinAreaItem15": {
            animationDelay: `${animMulti * 20}s`,
            ...baseCoinAreaAnimStyles,
        },
    },

    coinPic: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },

    particleWrapper: {
        minWidth: "320px",
        width: "fit-content",
        maxWidth: "1000px",
        height: "400px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        [theme.breakpoints.down("md")]: {
            justifyContent: "space-evenly",
            minWidth: "500px",
            maxWidth: "500px",
        },
        [theme.breakpoints.down("sm")]: {
            justifyContent: "center",
            minWidth: "320px",
            maxWidth: width,
        },
    },

    particleBox: {
        minWidth: "45px",
        maxWidth: "45px",
        height: "45px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            minWidth: "35px",
            maxWidth: "35px",
            height: "45px",
        },
        [theme.breakpoints.down("sm")]: {
            minWidth: "30px",
            maxWidth: "30px",
            height: "45px",
        },
    },

    "@keyframes dialogSpin": {
        "0%": {
            opacity: 0,
            transform: "scale(0.1)",
        },
        "10%": {
            opacity: 0,
            transform: "scale(0.1)",
        },
        "100%": {
            opacity: 1,
            transform: "scale(1)",
        },
    },
});
